export default "__VITE_ASSET__eobr38pt__"